import { render } from "./edit-schedule-template-user-modal.vue?vue&type=template&id=0b8ef2cc"
import script from "./edit-schedule-template-user-modal.vue?vue&type=script&lang=js"
export * from "./edit-schedule-template-user-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__